import { Dialog, Typography, Grid, MenuItem, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import DialogActionButtons from "../dialog/DialogActions";
import DialogBody from "../dialog/DialogBody";
import DialogHeader from "../dialog/DialogHeader";
import Label from "../label";
import CustomSelect from "../select";
import InputField from "../InputField";
import { appIcons } from "../../assets";

const paymentGateway = ["Cash Payment", "MTN Money", "Orange Mobile Money"];

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = {};

const PaymentMethodDialog = forwardRef(({ handleConfirm }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader title={"Select Payment Method!"} onClose={handleClose} />
      <DialogBody>
        <Grid container rowSpacing={3}>
          <Grid item xs={12}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Label text={"2nd Installment  (Auto)"} />
              <Label text={"USD"} />
            </Stack>
            <InputField
              InputStartIcon={<img src={appIcons.cashBlackIcon} width={18} />}
              value="200 USD"
            />
          </Grid>
          <Grid item xs={12}>
            <Label text={"Select Bank Account"} />
            <CustomSelect
              icon={<img src={appIcons.blackBankIcon} width={18} />}
            >
              {paymentGateway.map((type, index) => {
                return (
                  <MenuItem key={index} value={type}>
                    {type}
                  </MenuItem>
                );
              })}
            </CustomSelect>
          </Grid>
        </Grid>
      </DialogBody>
      <DialogActionButtons onCancel={handleClose} onConfirm={handleConfirm} />
    </BootstrapDialog>
  );
});

export default PaymentMethodDialog;
